import React from 'react';

const NotAuthorised: React.FC<{}> = (props) => {
    return (
        <div id="not-authorised">
            <h1>Oops!</h1>
            <p>Sorry, you are not authorised to access requested resource.</p>
        </div>
    );
}

export default NotAuthorised;